import React, { useEffect, useState } from "react";

import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { getUserBalance } from "../../services/balance";

export default function BalanceInfo() {
  const [balances, setBalances] = useState();
  const isTabletOrfirst = useMediaQuery({ query: "(max-width: 768px)" });
  useEffect(() => {
    getUserBalance().then((data) => {
      setBalances(data.data.data);
    });
  }, []);

  return (
    <div>
      {isTabletOrfirst && (
        <>
          <div>
            <div className="kifpool-title-right">موجودی کل</div>

            <div className="number-for-kifpool-final">
              {balances ? (
                new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 0,
                }).format(balances?.cash_balance) + " تومان "
              ) : (
                <>در حال بارگیری</>
              )}
            </div>
          </div>
          <div>
            <div className="kifpool-title-right">بلوکه شده</div>

            <div className="number-for-kifpool-final">
              {balances ? (
                new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 0,
                }).format(balances?.useless_cash_amount) + " تومان "
              ) : (
                <>در حال بارگیری</>
              )}
            </div>
          </div>
        </>
      )}
      {isTabletOrfirst ? (
        <div>
          <div className="kifpool-title-right">موجودی فعلی</div>

          <div className="number-for-kifpool-final">
            {balances ? (
              new Intl.NumberFormat("fa", { maximumFractionDigits: 0 }).format(
                balances?.cash_balance
              ) + " تومان "
            ) : (
              <>در حال بارگیری</>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="kifpool-desktop-balance">
            <div className="kifpool-title-right">کل موجودی</div>
            <div>
              {balances ? (
                new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 0,
                }).format(balances?.total_assets) + " تومان "
              ) : (
                <>در حال بارگیری</>
              )}
            </div>
          </div>
          <div className="kifpool-desktop-balance">
            <div className="kifpool-title-right">موجودی فعلی</div>
            <div>
              {balances ? (
                new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 0,
                }).format(balances?.cash_balance) + " تومان "
              ) : (
                <>در حال بارگیری</>
              )}
            </div>
          </div>
          <div className="kifpool-desktop-balance">
            <div className="kifpool-title-right">موجودی بلوکه شده</div>
            <div>
              {balances ? (
                new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 0,
                }).format(balances?.useless_cash_amount) + " تومان "
              ) : (
                <>در حال بارگیری</>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
